export const GET_PRODUCT_REQUEST="GET_PRODUCT_REQUEST"
export const GET_PRODUCT_SUCCESS="GET_PRODUCT_SUCCESS"
export const GET_PRODUCT_ERROR="GET_PRODUCT_ERROR"

export const SIGNUP_REQUEST ="SIGNUP_REQUEST";
export const SIGNUP_SUCCESS ="SIGNUP_SUCCESS";
export const SIGNUP_FAILURE ="SIGNUP_FAILURE";

